import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MaterialModule} from '../../../../../core/modules/material.module';
import {SharedModule} from '../../../../../core/modules/shared.module';
import {EventsService} from '../../../../../core/services/events.service';
import {finalize, forkJoin} from 'rxjs';

@Component({
  selector: 'add-skill-component',
  templateUrl: './add-skill.component.html',
  styleUrls: ['./add-skill.component.scss'],
  standalone: true,
  imports: [MaterialModule, SharedModule],
  providers: [EventsService]
})

export class AddSkillComponent {

  users;
  skills;
  showWarning = false;
  eventId;
  blockButton = false;
  closeButton = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<AddSkillComponent>,
              private eventService: EventsService) {
    console.log('data', data);
    if (data) {
      this.eventId = data.eventId;
      this.users = data.users.filter(el => !!el.frontUserId);
      this.showWarning = data.users.some(el => el.alreadySkilled);
      this.skills = data.skills;
    }
  }

  addSkills() {
    if (!this.blockButton) {
      this.blockButton = true;
      let requests = [];
      this.users.forEach((el) => {
        let body = {
          frontUserId: el.frontUserId,
          eventId: this.eventId
        };
        if (!el.alreadySkilled) {
          requests.push(this.eventService.addSkills(body));
        }
      });
      if (requests.length) {
        forkJoin(requests)
          .pipe(
            finalize(() => {
              this.blockButton = false;
            })
          )
          .subscribe({
            next: (results) => {
              results.forEach((result, index) => {
                if (result && !result.msg) {
                  let userIndex = this.users.findIndex(el => +el.frontUserId === +result[0].frontUserId);
                  this.users[userIndex]['newSkillAdded'] = true;
                }
              });
              this.closeButton = true;
            },
            error: (err) => {
              alert('Error');
              console.error('addSkills error', err);
              this.closeButton = true;
            }
          });
      }
    }
  }
}
